import { render } from "./SectionPortfolioDetailDesc.vue?vue&type=template&id=7d240c80&scoped=true"
import script from "./SectionPortfolioDetailDesc.vue?vue&type=script&lang=js"
export * from "./SectionPortfolioDetailDesc.vue?vue&type=script&lang=js"

import "./SectionPortfolioDetailDesc.vue?vue&type=style&index=0&id=7d240c80&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d240c80"]])

export default __exports__